import { useRouter } from 'next/router'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../proxies/proxyGlobalAuth'
import StandardPayInverseSignatureLogo from '../ui/logos/StandardPayInverseSignatureLogo'
import { type GlobalSiteDomainEnum } from '../../types/GlobalSiteDomainEnum'
import PrimarySignatureLogo from '../ui/logos/PrimarySignatureLogo'
import { Hamburger } from './Navbar/Hamburger'
import { Account } from './Navbar/Account'
import { SearchBar } from './Navbar/SearchBar'
import { MerchantSelector } from './Navbar/MerchantSelector'

interface NavbarProps {
  toggleExpanded: () => void
}

function DeterminePoweredBy ({ theme }: { theme: GlobalSiteDomainEnum }): ReactElement {
  if (theme === 'WASTE_PAY') {
    return <PrimarySignatureLogo />
  }
  return <StandardPayInverseSignatureLogo />
}

export function Navbar ({ toggleExpanded }: NavbarProps): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const router = useRouter()
  const { siteDomainEnum, siteTheme: { topNavBarColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <div
      className={cn(topNavBarColors.classes, 'w-screen flex flex-row items-center py-2 pr-6 justify-between shadow-xs')}
      style={{ height: '8vh', minHeight: '5rem' }}
    >
      <div className="flex flex-row items-center">
        <Hamburger onClick={toggleExpanded} />

        <DeterminePoweredBy theme={siteDomainEnum} />
        <div className="w-24" />
        <SearchBar />
      </div>

      <div className="flex mr-8 flex h-8">
        <MerchantSelector />
        <Account />
      </div>
    </div>
  )
}
